import type { RouteObject } from "react-router-dom";
import IamGrantsRoutes from "@/pages/iam/grants";
import IamGroupsRoutes from "@/pages/iam/groups";
import IamPoliciesRoutes from "@/pages/iam/policies";
import IamUsersRoutes from "@/pages/iam/users";
import SsoIntegration from "@/pages/iam/sso/SsoIntegration";

export const iamRoutes: RouteObject[] = [
  { path: "/iam/users/*", element: <IamUsersRoutes /> },
  { path: "/iam/groups/*", element: <IamGroupsRoutes /> },
  { path: "/iam/policies/*", element: <IamPoliciesRoutes /> },
  { path: "/iam/grants/*", element: <IamGrantsRoutes /> },
  { path: "/iam/sso", element: <SsoIntegration /> },
];
